// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"2f68b91d","703":"70c4e151","845":"f858bc42"}[chunkId] + ".chunk.js";
};